module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-header-wrapper"
  }, [_c('div', {
    staticClass: "container article-header"
  }, [_c('node-label', {
    attrs: {
      "node": _vm.node
    }
  }), (_vm.title) ? _c('div', {
    staticClass: "article-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('field-subheading', {
    attrs: {
      "subheading": _vm.node.subheading
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73e7b9c3","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/ArticleHeader.vue
// module id = 1179
// module chunks = 23 25